import { createFunctionAnnotation } from '../lambdas'
import {
  untrackBound as originBound,
  untrack as originFn
} from '../operations/register'

export const untrack = createFunctionAnnotation(
  'untrack',
  originFn,
  originBound
)
